import { Pipe, PipeTransform, inject } from '@angular/core';
import { IrisLocaleService } from '../../../locale/services/locale.service';
import { transformTranslate } from './translate.utils';

@Pipe({
  name: 'irisTranslate',
})
export class IrisTranslatePipe implements PipeTransform {
  private readonly localeService = inject(IrisLocaleService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any, translations, defaultValue?, currLocale?): any {
    return transformTranslate(value, translations, defaultValue, currLocale, this.localeService);
  }
}
